import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export type BadgeTone = "success" | "neutral" | "info" | "warning" | "danger";

const TONE_CLASSES: Record<BadgeTone, string> = {
  success: "bg-green-100 text-green-700",
  neutral: "bg-gray-100 text-gray-600",
  info: "bg-blue-100 text-blue-700",
  warning: "bg-amber-100 text-amber-700",
  danger: "bg-red-100 text-red-700",
};

/**
 * Shared soft-pill status badge used across admin tables (Active/Inactive,
 * Published/Draft, licence status, …). Standardizes the ad-hoc colored spans
 * each page used to roll by hand.
 */
export function StatusBadge({
  tone = "neutral",
  className,
  children,
}: {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium",
        TONE_CLASSES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
